import dayjs from "./dayjs";
import { formats } from "../constants";

export const getAdjustedDeliveryDays = (expectedDate) => {
    if (!expectedDate) return null;

    const today = dayjs().startOf('day');
    let expected = dayjs(expectedDate, formats.backendDateFormat).startOf('day');

    if (!expected.isValid()) return null;

    const dayOfWeek = expected.day();
    if (dayOfWeek === 6) {
        expected.add(2, 'days'); // Saturday → Monday
    } else if (dayOfWeek === 0) {
        expected.add(1, 'days'); // Sunday → Monday
    }

    return Math.max(0, expected.diff(today, 'days'));
};
